// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ygfL","name":"styles_name__2T5K5","phone":"styles_phone__1dM8P"};